export enum QueryKeys {
  USER_INFO_QUERY = 'user-info-query',
  TRAVEL_FORM_QUERY = 'travel-form-query',
  TRAVEL_QUERY_BY_ID = 'travel-query-by-id',
  TRAVEL_STATUS_UPDATE = 'travel-status-update',
  PROJECT_SEARCH = 'project-search',
  ACTIVITY_SEARCH = 'activity-search',
  DEPARTMENT_SEARCH = 'department-search',
  LOCATION_SEARCH = 'location-search',
  CALCULATE_DIMENSIONS = 'calculate-dimensions',
  TRAVEL_REQUESTS = 'travel-requests',
  ALL_TRAVEL_REQUESTS = 'all-travel-requests',
  PAYMENT_METHODS = 'payment-methods',
  EXPENSES_BY_ID = 'expenses-by-id',
  DAILY_ALLOWANCE_BY_ID = 'daily-allowance-by-id',
  EXPENSES_FORM_QUERY = 'expenses-form-query',
  EXPENSES_ATTACHMENT_FOR_REQUEST = 'expenses-attachment-for-request',
  EXPENSES_ATTACHMENT = 'expenses-attachment',
  UPDATE_EXPENSE_BY_ID = 'update-expense-by-id',
  UPDATE_DAILY_ALLOWANCE_BY_ID = 'update-daily-allowance-by-id',
  DAILY_ALLOWANCE_FORM_QUERY = 'daily-allowance-form-query',
  PER_DIEM_OPTIONS = 'per-diem-options',
  EMPLOYEE_SEARCH = 'employee-search',
  ACTIVITY_LOGS = 'activity-logs',
  APPROVERS_LIST = 'approvers-list',
  APPROVERS_DEPARTMENTS = 'approvers-departments',
  CREATE_APPROVER = 'create-approver',
  UPDATE_APPROVER = 'update-approver',
  DELETE_APPROVER = 'delete-approver',
  DELETE_ATTACHMENT = 'delete-attachment',
  DELETE_COST_LINE = 'delete-cost-line',
  UPDATE_AGENT_ACTIONS = 'update-agent-actions',
  ALL_NOTIFICATIONS_EMAIL = 'all-notifications-email',
}
